module.exports = __webpack_public_path__ + "static/img/Consulting01.313ed4a4.png";